import { Box, Tabs, Tab } from "grommet";
import React, { useState } from "react";
import DbtCodes from "../Components/DbtCodes";
import ABMDI from "../Components/PodIntegrations/ABMDI";
import Tocico from "../Components/PodIntegrations/Tocico";
import FDMS from "../Components/FDMS";

import ExamCodeSelector from "../Components/ExamCodeSelector";
import HPECodes from "../Components/HPECodes";
import PSHRA from "../Components/PSHRA";
import NewExamCodes from "../Components/NewExamCodes";
function ExamCodes() {
  const [index, setIndex] = useState(0);

  const onActive = (nextIndex) => {
    setIndex(nextIndex);
  };
  return (
    <Box>
      <Tabs activeIndex={index} onActive={onActive} justify="center">
        <Tab title="Exam Codes">
          <Box align="stretch" justify="center">
            <NewExamCodes />
          </Box>
        </Tab>
        <Tab title="FDMS Links">
          <Box align="stretch" justify="center">
            <FDMS />
          </Box>
        </Tab>
        <Tab title="HPE Links">
          <Box align="stretch" justify="center">
            <HPECodes />
          </Box>
        </Tab>
        <Tab title="PSHRA Codes">
          <Box align="stretch" justify="center">
            <PSHRA />
          </Box>
        </Tab>
        <Tab title="ABMDI Links">
          <Box align="center" justify="center">
            <ABMDI />
          </Box>
        </Tab>
        <Tab title="TOCICO Links">
          <Box align="center" justify="center">
            <Tocico />
          </Box>
        </Tab>
      </Tabs>
    </Box>
  );
}

export default ExamCodes;
